// Types
const action_header = "finance/";

export default {
  GET_TRANSACTION_RECORD: action_header + "GET_TRANSACTION_RECORD",
  GET_TRANSACTION_RECORD_SUCCESS: action_header + "GET_TRANSACTION_RECORD_SUCCESS",
  GET_TRANSACTION_RECORD_FAILED: action_header + "GET_TRANSACTION_RECORD_FAILED",
};
